import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { connect, useStore } from 'react-redux';
import useMedia from "use-media";
import commonUtil from '../../../common/commonUtil';
import { getFacilityInfo, getVacancyList, vacancyPublic, getShisetsuGradeList } from '../../../const';
import messageConst from '../../../const/messageConst';
import { GetPublicHoliday } from "../../../hooks/getPublicHoliday";
import "../../../resources/css/search/search.css";
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import { Label } from '../../atoms/label';
import { OptionPullDown } from '../../atoms/optionPullDown';
import { ErrorMassage } from '../../molecules/errorMassage';
import { ModalOptionForm } from '../../molecules/modalOptionForm';
import { PullDownOptionForm } from '../../molecules/pullDownOptionForm';
import './../../../resources_membership_hotel/css/hotel/reserve.css';
import './../../../resources_membership_hotel/css/hotel/membership_vacancy.css';
import arrow from '../../../resources/icons/arw-bottom.png';
import cross from '../../../resources/icons/ico_X.svg';
import circle from '../../../resources_membership_hotel/icons/ico_circle.svg';
import minus from '../../../resources_membership_hotel/icons/ico_minus.svg';
import slash from '../../../resources_membership_hotel/icons/ico_slash.svg';
import square from '../../../resources_membership_hotel/icons/ico_square.svg';
import triangle from '../../../resources_membership_hotel/icons/ico_triangle.svg';
import ico_square_blue from '../../../resources_membership_hotel/icons/ico_square_blue.svg';
import ico_square_gold from '../../../resources_membership_hotel/icons/ico_square_gold.svg';
import ico_square_red from '../../../resources_membership_hotel/icons/ico_square_red.svg';
import ico_square_white from '../../../resources_membership_hotel/icons/ico_square_white.svg';
import { Image } from "../../atoms/image";
import { ImageButton } from '../../atoms/imageButton';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import { getGradeListParam, replaceLineBreakCharToLineBreak } from '../../../pages_membership_hotel/hotel/membershipVacancy';


const VacancyContainer = (props) => {
    const {
        playDate1,
        room,
        checkIn,
        firstDate,
        setRoom,
        resvKaiinken,
        setResvKaiinken,
        // grade,
        adultNum,
        childNum,
        setAdultNum,
        setChildNum,
        setCheckOut,
        setPlanConditions,
        // setGrade,
        setFacilityItem, // カレンダーに施設選択状態を渡してカレンダ選択で空室検索する用 shisetsuCd, selected
        setFood,
        setPrivilegedService,
        // setMembershipFacility,
        // membershipFacility,
        onClickCheckIn,
        gradeData, // Redux Storeのグレードリスト(ログイン後はgradeを使っているから被らない)
        setGradeData,
        onClickOpenCheckListWindow,
        setVacancyList,
        // MonthHead,
        // setMonthHead,
        vacancyWeek,
        displaySwitch,
        openGradePopup,
        facilityData,
        setFacilityData,
        openFacilityPopup} = props;

    const { getHoliday } = GetPublicHoliday();

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const [mobilePhone, setMobilePhone] = useState(false);
    const [vacancyOverview, setVacancyOverview] = useState([]);
    const [weekList, setWeekList] = useState([]);
    const [nextFlag, setNextFlag] = useState(false);
    const [NotSearch, setNotSearch] = useState(false);

    const [roomNumber, setRoomNumber] = useState("1");
    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");
    const [gradeNumber, setGradeNumber] = useState("1");
    const [dispAdultNum, setDispAdultNum] = useState("2");
    const [dispChildNum, setDispChildNum] = useState("0");
    const [msgAcoddion, setMsgAcoddion] = useState(false);
    // // getShisetsuGradeListレスポンスのshisetsuInfo＋選択、グループ開閉状態保持
    // const [facilityData, setFacilityData] = useState([]);
    const facilityLabelAll = "全施設表示";
    const [facilityLabel, setFacilityLabel] = useState(facilityLabelAll);
    const grandeLabelAll = "全グレード表示";
    const [selectDate, setSelectDate] = useState();

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [errFlgList, setErrFlgList] = useState({ errFacility: false });

    const getGradeLabel = (gradeData) => {

        if (!gradeData) {
            return grandeLabelAll;
        }
        const selectedGrades = gradeData.filter(data => {
            return data.checked;
        });
        if (selectedGrades.length === 0) {
            return grandeLabelAll;
        }
        const ret = selectedGrades.map(item => {
            return item.value;
        }).join(", ");
        
        return ret;
    }

    // 施設選択ポップアップ表示状態
    // const [showFacilityPopup, setShowFacilityPopup] = useState(false);

    // const openFacilityPopup = () => {
    //     setShowFacilityPopup(true);
    // }
    // const closeFacilityPopup = () => {
    //     setShowFacilityPopup(false);
    // }
    const facilityDataToFacilityItem = (facility) => {
        if (!facility) {
            return [];
        }
        const shisetsuList = hotelListToFacilityItem(facility.memberHotelList).concat(hotelListToFacilityItem(facility.generalHotelList));
        // 未選択なら全施設検索とするためにデータ追加
        // const anySelected = shisetsuList.some(item => item.selected);
        // if (!anySelected) {
        //     shisetsuList.unshift({
        //         // id: '1',
        //         // value: '全施設表示',
        //         shisetsuCd: null,
        //         selected: true
        //     })
    
        // }
        return shisetsuList;
    }
    const hotelListToFacilityItem = (hotelList) => {
        const ret = [];
        if (!hotelList) {
            return ret;
        }

        for (const group of hotelList) {
            if (!group.shisetsuList) {
                continue;
            }
            for (const hotel of group.shisetsuList) {
                ret.push({
                    shisetsuCd: hotel.shisetsuCd,
                    selected: hotel.selected
                })
            }
        }
        return ret;
    }
    // 表示用施設名の改行を表す文字を改行に変換
    const convertShisetuNameDispLineBreak = (facility) => {
        if (!facility) {
            return facility;
        }
        facility.generalHotelList = convertHotelListShisetuNameDispLineBreak(facility.generalHotelList);
        facility.memberHotelList = convertHotelListShisetuNameDispLineBreak(facility.memberHotelList);
        return facility;
    }
    const convertHotelListShisetuNameDispLineBreak = (hotelList) => {
        for (const group of hotelList) {
            for (const shisetsu of group.shisetsuList) {
                shisetsu.webNamePc = replaceLineBreakCharToLineBreak(shisetsu.webNamePc);
                shisetsu.webNameSp = replaceLineBreakCharToLineBreak(shisetsu.webNameSp);
            }
        }
        return hotelList;
    }


    const facilityDataToDispLabel = (facility) => {
        const memberLabel = hotelListToDispLabel(facility.memberHotelList)
        const generalLabel = hotelListToDispLabel(facility.generalHotelList);
        let ret = memberLabel;
        if (ret && generalLabel) {
            ret += ", ";
        }
        ret += generalLabel;
        if (!ret) {
            ret = facilityLabelAll;
        }

        return ret;
    }
    const hotelListToDispLabel = (hotelList) => {
        let ret = "";
        if (!hotelList) {
            return ret;
        }

        for (const group of hotelList) {
            if (!group.shisetsuList) {
                continue;
            }
            for (const hotel of group.shisetsuList) {
                if (!hotel.selected) {
                    continue;
                }
                if (ret) {
                    ret += ", ";
                }
                ret += hotel.shisetsuName;

            }
        }
        return ret;
    }


    const store = useStore();
    let twoWeeks = [];

    const getShisetsuGradeListLocalData={
        "resultCode": "0",
        "shisetsuInfo": {
            "memberHotelList": [
                {
                    "mainGroupCd": "1",
                    "mainGroupName": "★ローカル＿ベイコート倶楽部・サンクチュアリコート",
                    "shisetsuList": [
                        {
                            "shisetsuCd": "401",
                            "shisetsuName": "★ローカル＿東京ベイコート倶楽部",
                            "webNamePc": "★ローカル＿東京\\r\\nベイコート倶楽部",
                            "webNameSp": "★ローカル＿東京\\r\\nベイコート倶楽部",
                            "enable": false
                        },
                        {
                            "shisetsuCd": "404",
                            "shisetsuName": "★ローカル横浜ベイコート倶楽部",
                            "webNamePc": "★ローカル横浜\\r\\nベイコート倶楽部",
                            "webNameSp": "★ローカル＿横浜\\r\\nベイコート倶楽部",
                            "enable": false
                        },
                        {
                            "shisetsuCd": "403",
                            "shisetsuName": "★ローカルラグーナベイコート倶楽部",
                            "webNamePc": "★ローカルラグーナ\\r\\nベイコート倶楽部",
                            "webNameSp": "★ローカルラグーナ\\r\\nベイコート倶楽部",
                            "enable": false
                        },
                    ]
                },
                {
                    "mainGroupCd": "2",
                    "mainGroupName": "★ローカル＿エクシブ（東日本）",
                    "shisetsuList": [
                        {
                            "shisetsuCd": "217",
                            "shisetsuName": "★ローカル＿エクシブ那須白河",
                            "webNamePc": "★ローカル＿エクシブ\\r\\n那須白河",
                            "webNameSp": "★ローカル＿エクシブ\\r\\n那須白河",
                            "enable": true
                        },
                        {
                            "shisetsuCd": "218",
                            "shisetsuName": "★ローカル＿エクシブ那須白河　ドギーヴィラ",
                            "webNamePc": "★ローカル＿エクシブ那須白河\\r\\nドギーヴィラ",
                            "webNameSp": "★ローカル＿エクシブ那須白河\\r\\nドギーヴィラ",
                            "enable": true
                        },
    
                    ]
                },
    
            ],
            "generalHotelList": [
                {
                    "mainGroupCd": "5",
                    "mainGroupName": "★ローカル＿ホテルトラスティ",
                    "shisetsuList": [
                        {
                            "shisetsuCd": "504",
                            "shisetsuName": "★ローカル＿ホテルトラスティ東京ベイサイド",
                            "webNamePc": "★ローカル＿ホテルトラスティ\\r\\n東京ベイサイド",
                            "webNameSp": "★ローカル＿ホテルトラスティ\\r\\n東京ベイサイド",
                            "enable": true
                        },
                        {
                            "shisetsuCd": "115",
                            "shisetsuName": "★ローカル＿ホテルトラスティ名古屋　白川",
                            "webNamePc": "★ローカル＿ホテルトラスティ\\r\\n名古屋　白川",
                            "webNameSp": "★ローカル＿ホテルトラスティ\\r\\n名古屋　白川",
                            "enable": true
                        },
                        {
                            "shisetsuCd": "506",
                            "shisetsuName": "★ローカル＿ホテルトラスティ大阪　阿倍野",
                            "webNamePc": "★ローカル＿ホテルトラスティ\\r\\n大阪　阿倍野",
                            "webNameSp": "★ローカル＿ホテルトラスティ\\r\\n大阪　阿倍野",
                            "enable": true
                        }
                    ]
                },
                {
                    "mainGroupCd": "6",
                    "mainGroupName": "★ローカル＿ザ・カハラ・ホテル＆リゾート",
                    "shisetsuList": [
                        {
                            "shisetsuCd": "003",
                            "shisetsuName": "★ローカル＿ザ・カハラ・ホテル＆リゾート 横浜",
                            "webNamePc": "★ローカル＿ザ・カハラ・ホテル＆\\r\\nリゾート 横浜",
                            "webNameSp": "★ローカル＿ザ・カハラ・ホテル＆\\r\\nリゾート 横浜",
                            "enable": true
                        }
                    ]
                }
            ]
        },
        "roomGradeList": [
            {
                "gradeId": "PM00000005",
                "gradeName": "★ローカル_Aグレード",
                "gradeApiValue": "A"
            },
            {
                "gradeId": "PM00000006",
                "gradeName": "★ローカル_Cグレード",
                "gradeApiValue": "C"
            },
            {
                "gradeId": "PM00000007",
                "gradeName": "★ローカル_Eグレード",
                "gradeApiValue": "E"
            },
        ]
    }

    const vacancyPublicLocalData = {
        "resultCode": "0",
        "startDate": "2022-06-11",
        "kushitsuList": [
            {
                "honkanShisetsuCd": "401",
                "shisetsuCd": "401",
                "shisetsuName": "★ローカル＿東京ベイコート倶楽部",
                "sortNo": 1,
                "kushitsuDateList": [
                    {
                        "riyoDate": "2022-06-11",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-12",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-13",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-14",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-15",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-16",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-17",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-18",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-19",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-20",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-21",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-22",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-23",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-24",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-25",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-26",
                        "kushitsuMark": "×",
                        "iroKbn": "red"
                    }
                ]
            },
            {
                "honkanShisetsuCd": "402",
                "shisetsuCd": "402",
                "shisetsuName": "★ローカル＿芦屋ベイコート倶楽部",
                "sortNo": 4,
                "kushitsuDateList": [
                    {
                        "riyoDate": "2022-06-11",
                        "kushitsuMark": "△",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-12",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-13",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-14",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-15",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-16",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-17",
                        "kushitsuMark": "△",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-18",
                        "kushitsuMark": "△",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-19",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-20",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-21",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-22",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-23",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    },
                    {
                        "riyoDate": "2022-06-24",
                        "kushitsuMark": "△",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-25",
                        "kushitsuMark": "△",
                        "iroKbn": "red"
                    },
                    {
                        "riyoDate": "2022-06-26",
                        "kushitsuMark": "△",
                        "iroKbn": "white"
                    }
                ]
            },
            {
                "honkanShisetsuCd": "506",
                "shisetsuCd": "506",
                "shisetsuName": "★ローカル＿ホテルトラスティ大阪　阿倍野",
                "sortNo": 43,
                "kushitsuDateList": [
                    {
                        "riyoDate": "2022-06-11",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-12",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-13",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-14",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-15",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-16",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-17",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-18",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-19",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-20",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-21",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-22",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-23",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-24",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-25",
                        "kushitsuMark": "○"
                    },
                    {
                        "riyoDate": "2022-06-26"
                    }
                ]
            }
        ]
    }

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);

    useEffect(() => {
        // //ローカルAPI
        // initializeSetWeekList();

        common.doPost(getShisetsuGradeList, {}, afterGetShisetsuGrateList);
        // ★ローカル確認用 ↓↓↓

        // sleep(2000).then(() => {
        //     afterGetShisetsuGrateList({ data: getShisetsuGradeListLocalData })            
        // })
        // ★ローカル確認用 ↑↑↑


    }, []);
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // 2週間表示の初期化
    const initializeSetWeekList = () => {
        // 検索基準の日付を設定
        const iniCheckInDate = new Date();
        iniCheckInDate.setDate(iniCheckInDate.getDate() + 3);

        // 2週間分の日付情報
        twoWeeks = getWeekList(iniCheckInDate);
        // getYearMonth(twoWeeks, iniCheckInDate)
        store.dispatch({ type: "VACANCY_WEEK", payload: { vacancyWeek: twoWeeks } });
    }

    // 2週間分の日付情報
    const getWeekList = (nextDate) => {
        console.log(nextDate);
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const array = [];
        for (let i = 0; i < 14; i++) {
            const date = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + i);

            let color = "";
            switch (date.getDay()) {
                case 0:
                    color = "red";
                    break;
                case 6:
                    color = "blue";
                    break;
                default:
                    color = "black";
                    break;
            }

            // 祝日は赤色に変更
            let holiday = getHoliday(date, date, "month");
            if (holiday === "react-calendar__tile_holiday") {
                color = "red";
            }

            const week = {
                day: date.getDate().toString(),
                month: date.getMonth(),
                week: youbi[date.getDay()],
                color: color,
                date: date,
            }
            array.push(week);
        }
        return array;
    }

    // チェックイン表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(checkIn);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();
        console.log(`${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`);


        return `${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`;
    }

    // カレンダーの年月の表示
    // 日付と連動
    const getYearMonth = (checkIn) => {
        if (!checkIn) {
            return null;
        }

        const checkInDate = new Date(checkIn);
        const twoWeeks = getWeekList(checkInDate);

        const yr = checkInDate.getFullYear();
        const mHead = twoWeeks[0].month
        const mLast = twoWeeks[13].month

        if ((!isMobilePhone && twoWeeks[0].month === twoWeeks[13].month) || (isMobilePhone &&  twoWeeks[0].month === twoWeeks[6].month)) {
            // setMonthHead(<p style={style.yearMonthP}><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月</span></p>);
            return <p style={style.yearMonthP}><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月</span></p>;
        } else {
            // setMonthHead(<p style={style.yearMonthP}><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月 ~ {mLast + 1}月</span></p>);
            return <p style={style.yearMonthP}><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月 ~ {mLast + 1}月</span></p>;
        }
    }



    // 初期表示の施設取得後、施設選択、グレード選択時に空室検索する処理
    useEffect(() => {
        if (facilityData) {
            onChangeFacility(facilityData, gradeData);
        }
    }, [facilityData, gradeData]);

    // 施設決定ハンドラ
    const onChangeFacility = (facility, gradeData) => {
        // const facility = facilityData
        // facility.forEach((data) => {
        //     if (data.id === e.target.value) {
        //         data.selected = true;
        //     } else {
        //         data.selected = false;
        //     }
        // })
        // setShowFacilityPopup(false);        
        setFacilityData(facility);
        const facilityItem = facilityDataToFacilityItem(facility);
        setFacilityItem(facilityItem)
        setFacilityLabel(facilityDataToDispLabel(facility))

        // const targetFacilityDataItem = facilityItem.filter(data => {
        //     return data.selected
        // }).map(item => item.shisetsuCd)
        const shisetsuCdList = getShisetsuCdListParamFromsFacilityItem(facilityItem)
        // const targetGradeItem = gradeData.filter(data => {
        //     return data.selected
        // })[0].grade

        // const roomGradeList = targetGradeItem ? [targetGradeItem] : null
        const roomGradeList = getGradeListParam(gradeData);
        const checkInDate = new Date(checkIn)
        const riyoDateFrom = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd")
        const end = new Date(riyoDateFrom)
        end.setDate(end.getDate() + 14)
        const riyoDateTo = commonUtil.getStringFromDate(end, "yyyy-MM-dd")

        const param = {
            shisetsuCdList,
            roomGradeList,
            riyoDateFrom,
            riyoDateTo
        }

        common.doPost(vacancyPublic, param, afterVacancyPublic);
        // ★ローカル確認用 ↓↓↓
        // sleep(2000).then(() => {
        //     afterVacancyPublic({ data: vacancyPublicLocalData })
        // })
        // ★ローカル確認用 ↑↑↑

    }
    const getShisetsuCdListParamFromsFacilityItem = (facilityItem) => {
        const targetFacilityDataItem = facilityItem.filter(data => {
            return data.selected
        }).map(item => item.shisetsuCd)
        const shisetsuCdList = targetFacilityDataItem.length > 0 ? targetFacilityDataItem : null
        return shisetsuCdList;
    }

    //グレード変更処理
    // const onChangeGrade = (e) => {
    //     gradeData.forEach((data) => {
    //         if (data.id === e.target.value) {
    //             data.selected = true;
    //         } else {
    //             data.selected = false;
    //         }
    //     })
    //     setGradeData(gradeData);
    //     const facilityItem = facilityDataToFacilityItem(facilityData);
    //     const shisetsuCdList = getShisetsuCdListParamFromsFacilityItem(facilityItem)
    //     // const targetGradeItem = gradeData.filter(data => {
    //     //     return data.selected
    //     // })[0]
    //     const checkInDate = new Date(checkIn)
    //     const riyoDateFrom = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd")
    //     // const roomGradeList = targetGradeItem ? [targetGradeItem.grade] : null
    //     const roomGradeList = getGradeListParam(gradeData);
    //     const end = new Date(riyoDateFrom)
    //     end.setDate(end.getDate() + 14)
    //     const riyoDateTo = commonUtil.getStringFromDate(end, "yyyy-MM-dd")
    //     const param = {
    //         shisetsuCdList,
    //         roomGradeList,
    //         riyoDateFrom,
    //         riyoDateTo
    //     }

    //     common.doPost(vacancyPublic, param, afterVacancyPublic);
    // }

    // 空室情報取得後処理
    const afterVacancyPublic = (res) => {
        if (res.data.resultCode !== '0') return
        const startDate = new Date(res.data.startDate)
        // 2週間分の日付情報
        let twoWeeks = getWeekList(startDate);

        // ２週間の日付表示を更新
        store.dispatch({ type: "VACANCY_WEEK", payload: { vacancyWeek: twoWeeks } });
        // getYearMonth(twoWeeks, startDate);

        const kushitsuList = [];
        res.data.kushitsuList.forEach(value => {
            kushitsuList.push({
                facilityId: value.shisetsuCd,
                facilityName: value.shisetsuName,
                vacancyDateList: value.kushitsuDateList
            })
        })
        props.setVacancyInfo(kushitsuList);
        setVacancyList(kushitsuList);
    }

    const afterGetShisetsuGrateList = (res) => {
        if (res.data.resultCode !== '0') return
        // const shisetsuList = res.data.shisetsuList.map((item, index) => {
        //     return {
        //         id: String(index + 2),
        //         value: item.shisetsuName,
        //         shisetsuCd: item.shisetsuCd,
        //         selected: false
        //     }
        // })
        const shisetsuList = facilityDataToFacilityItem(res.data.shisetsuInfo);
        // shisetsuList.unshift({
        //     id: '1',
        //     value: '全施設表示',
        //     shisetsuCd: null,
        //     selected: true
        // })

        const gradeList = res.data.roomGradeList.map((item, index) => {
            return {
                id: String(index + 1),
                value: item.gradeName,
                grade: item.gradeApiValue,
                checked: false,
                gradeId: item.gradeId,
            }
        })
        // gradeList.unshift({
        //     id: '1',
        //     value: '全グレード表示',
        //     grade: null,
        //     selected: true
        // })

        setGradeData(gradeList);
        // setFacilityData(shisetsuList);
        setFacilityData(convertShisetuNameDispLineBreak(res.data.shisetsuInfo));
        // setMembershipFacility(shisetsuList);
        setFacilityItem(shisetsuList);
        setFacilityLabel(facilityDataToDispLabel(res.data.shisetsuInfo))

        const shisetsuCdList = null
        const roomGradeList = null
        const checkInDate = new Date()
        checkInDate.setDate(checkInDate.getDate() + 3)
        const riyoDateFrom = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd")
        const end = new Date(riyoDateFrom)
        end.setDate(end.getDate() + 14)
        const riyoDateTo = commonUtil.getStringFromDate(end, "yyyy-MM-dd")
        const param = {
            shisetsuCdList,
            roomGradeList,
            riyoDateFrom,
            riyoDateTo
        }
        // common.doPost(vacancyPublic, param, afterVacancyPublic);
    }

    //注意書きアコーディオン修正
    const onClickNextView = () => {
        setMsgAcoddion(!msgAcoddion);
    }

    //カレンダー＜＞ボタン押下時
    const calLink = (isBack, mobile) => {
        const newDate = new Date(checkIn);
        if (isBack) {
            if (mobile) {
                newDate.setDate(newDate.getDate() - 7);
            } else {
                newDate.setDate(newDate.getDate() - 14);
            }
        } else {
            if (mobile) {
                newDate.setDate(newDate.getDate() + 7);
            } else {
                newDate.setDate(newDate.getDate() + 14);
            }
        }
        const nextYearDate = new Date();
        nextYearDate.setFullYear(nextYearDate.getFullYear() + 1);

        if (firstDate > newDate || newDate > nextYearDate) return;

        const facilityItem = facilityDataToFacilityItem(facilityData);
        const shisetsuCdList = getShisetsuCdListParamFromsFacilityItem(facilityItem);
        // const tfDataItem = facilityData.filter(data => {
        //     return data.selected
        // })[0].shisetsuCd
        // const shisetsuCdList = tfDataItem ? [tfDataItem] : null
        // const tgItem = gradeData.filter(data => {
        //     return data.selected;
        // })[0].grade;
        // const roomGradeList = tgItem ? [tgItem] : null;
        const roomGradeList = getGradeListParam(gradeData);

        const checkOutDate = new Date(newDate);
        checkOutDate.setDate(checkOutDate.getDate() + 13);

        const startTime = commonUtil.getStringFromDate(newDate, "yyyy-MM-dd");
        const endTime = commonUtil.getStringFromDate(checkOutDate, "yyyy-MM-dd");

        // const weekList = getWeekList(newDate)
        store.dispatch({ type: "CHECKIN", payload: { checkIn: newDate } });
        // store.dispatch({ type: "VACANCY_WEEK", payload: { vacancyWeek: weekList } });
        const param = {
            shisetsuCdList,
            roomGradeList,
            riyoDateFrom: startTime,
            riyoDateTo: endTime
        }

        common.doPost(vacancyPublic, param, afterVacancyPublic);
        // ★ローカル確認用 ↓↓↓
        // sleep(2000).then(() => {
        //     afterVacancyPublic({ data: vacancyPublicLocalData })
        // })
        // ★ローカル確認用 ↑↑↑
    }

    return (<>
        <div style={style.container}>
            <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
            </div>
            <div style={style.titleMessage} className="membership_vacancy_titlemsg">
                本日より1年先までのホテル空室情報です。<br />
            </div>
            <div className='membership_vacancy_titleinfo'>
                <hr className='membership_vacancy_line' />
                <div className='membership_vacancy_accArea'>
                    <div style={style.textLeft} className='membership_vacancy_acc_title'>
                        表記について
                    </div>
                    <div>
                        <div style={!msgAcoddion ? style.none : style.display} onClick={onClickNextView}>∧</div>
                        <div style={msgAcoddion ? style.none : style.display} onClick={onClickNextView}>∨</div>
                    </div>
                </div>
                {
                    msgAcoddion ?
                        <div className='membership_vacancy_acc_info'>
                            {!mobilePhone ?
                                <>
                                    ※サンメンバーズとザ・ロッジの客室タイプは、すべてが「スタンダード」タイプです。<br />
                                    ※本日・明日・明後日のご予約はお電話にてご連絡ください。<br />
                                    ※「空室あり」の表示になっていても、ご契約会員権の権利や占有日の使用状況によっては、ご予約になれない場合がございます。<br />
                                </>
                                :
                                <>
                                    <div className='membership_vacancy_acc_bodymb'>
                                        <div>※</div>
                                        <div>サンメンバーズとザ・ロッジの客室タイプは、すべてが「スタンダード」タイプです。</div>
                                    </div>
                                    <div className='membership_vacancy_acc_bodymb'>
                                        <div>※</div>
                                        <div>本日・明日・明後日のご予約はお電話にてご連絡ください。</div>
                                    </div>
                                    <div className='membership_vacancy_acc_bodymb'>
                                        <div>※</div>
                                        <div>「空室あり」の表示になっていても、ご契約会員権の権利や占有日の使用状況によっては、ご予約になれない場合がございます。</div>
                                    </div>
                                </>
                            }
                        </div>
                        :
                        null
                }
                <hr className='membership_vacancy_line2' />
            </div>
            <div className='membership_vacancy_calinfo'>
                <div style={style.tableImageStyle}>
                    <Image image={circle} className="membership_vacancy_calico" />
                    <Label label={"･･･空室あり"} className="membership_vacancy_callab" />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={triangle} className="membership_vacancy_calico" />
                    <Label label={"･･･残りわずか"} className="membership_vacancy_callab" />
                </div>
                {/* {!mobilePhone &&
                    <div style={style.tableImageStyle} >
                        <Image image={square} className="membership_vacancy_calico" />
                        <Label label={"･･･交換・キャンセル待ち"} className="membership_vacancy_callab" />
                    </div>
                } */}
                <div style={style.tableImageStyle} >
                    <Image image={cross} className="membership_vacancy_calico" />
                    <Label label={"･･･満室"} className="membership_vacancy_callab" />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={minus} className="membership_vacancy_calico" />
                    <Label label={"･･･クローズ"} className="membership_vacancy_callab" />
                </div>
                {/* {!mobilePhone &&
                    <div style={style.tableImageStyle} >
                        <Image image={slash} className="membership_vacancy_calico" />
                        <Label label={"･･･予約受付対象外"} className="membership_vacancy_callab" />
                    </div>
                } */}
                {/* {!mobilePhone &&
                    <div style={style.tableImageStyle} >
                        <Label label={"占"} className="membership_vacancy_calico" />
                        <Label label={"･･･占有日"} className="membership_vacancy_callab" />
                    </div>
                } */}
            </div>
            {/* {!mobilePhone &&
                <div>
                    <div style={{ display: "flex" }}>
                        <div style={style.tableImageStyle}>
                            <Image image={ico_square_gold} className="membership_vacancy_calico" />
                            <Label label={"･･･ゴールド"} className="membership_vacancy_callab" />
                        </div>
                        <div style={style.tableImageStyle} >
                            <Image image={ico_square_red} className="membership_vacancy_calico" />
                            <Label label={"･･･レッド"} className="membership_vacancy_callab" />
                        </div>
                        <div style={style.tableImageStyle} >
                            <Image image={ico_square_white} className="membership_vacancy_calico" />
                            <Label label={"･･･ホワイト"} className="membership_vacancy_callab" />
                        </div>
                        <div style={style.tableImageStyle} >
                            <Image image={ico_square_blue} className="membership_vacancy_calico" />
                            <Label label={"･･･ブルー"} className="membership_vacancy_callab" />
                        </div>
                    </div>
                </div>
            } */}
            <div className='membership_vacancy_cal'>
                <div className='membership_vacancy_link' onClick={() => calLink(true, mobilePhone)}>＜</div>
                <div>{getYearMonth(checkIn)}</div>
                <div className='membership_vacancy_link' onClick={() => calLink(false, mobilePhone)}>＞</div>
            </div>
            <div className="membership_vacancy_formarea">
                {/* <div style={NotSearch ? { display: "block", color: "red", textAlign: "center", fontSize: "0.8rem", background: "rgba(255,255,255,0)", border: 0, fontWeight: "bold" } : { display: "none" }} > 検索に失敗しました</div> */}
                <div className="membership_vacancy_form">
                    {/* <PullDownOptionForm
                        id="facility"
                        divClass={mobilePhone ? "wrapMobile" : "membership_vacancy_fac_wrap"}
                        title={""}
                        selectClass="membership_vacancy_select"
                        labelClassName="modalLabel"
                        data={facilityData}
                        onChange={onChangeFacility}
                    /> */}
                    <ModalOptionForm
                        id={"facility"}
                        // divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                        divClass={mobilePhone ? "wrapMobile" : "membership_vacancy_fac_wrap"}
                        // title={"施設"}
                        onClick={facilityData ? openFacilityPopup : null}
                        text={facilityLabel}
                        dateClass={errFlgList.errFacility ? "popupButtonErr" : ""} />
                    {/* <PullDownOptionForm
                        id="grade"
                        divClass={mobilePhone ? "wrapMobile" : "membership_vacancy_grade_wrap"}
                        title={""}
                        selectClass="membership_vacancy_select"
                        labelClassName="modalLabel"
                        data={gradeData}
                        onChange={onChangeGrade}
                    /> */}
                    <ModalOptionForm
                        id={"grade"}
                        // divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                        divClass={mobilePhone ? "wrapMobile" : "membership_vacancy_grade_wrap"}
                        onClick={facilityData ? openGradePopup : null}
                        text={getGradeLabel(gradeData)}
                         />
                    <div className="membership_vacancy_cal_area">
                        <ModalOptionForm
                            divClass={mobilePhone ? "wrapMobile" : "membership_vacancy_cal_wrap"}
                            title={""}
                            text={getDateToString()}
                            // dateClass={"membership_vacancy_cal_noimg"}
                            onClick={onClickCheckIn}
                        />
                        {/* <div id="dateSelection" className='membership_vacancy_cal_wrap2' onClick={onClickCheckIn}></div> */}
                    </div>
                </div>

            </div>
        </div>
        </>
    );
}



const style = {
    container: {
        marginRight: "auto",
        marginLeft: "auto",
    },
    vacancy__title: {
        fontWeight: "bold",
        textAlign: "left",
        marginBottom: "20px",
        height: "25px",
    },
    searchConditions: {
        width: "100%",
        marginTop: "30px"
    },
    searchbox: {
        width: "100%",
        padding: "10px 0px 50px 0px",
        margin: "10px auto"
    },
    searchboxMobile: {
        width: "100%",
        padding: "10px 0px 0px 0px",
        margin: "10px auto"
    },
    notesArea: {
        textAlign: "left",
        color: "rgb(170, 170, 170)",
    },
    notesAreaMobile: {
        padding: "10px 0",
        textAlign: "left",
        color: "rgb(170, 170, 170)",
        fontSize: "small",
    },
    search: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    monthStyle: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        marginLeft: "5px",
    },
    monthStyleMobile: {
        fontWeight: "bold",
        fontSize: "1rem",
        marginLeft: "5px",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "center",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    tableImageStyle: {
        display: "flex",
    },
    none: {
        display: "none"
    },
    display: {
        display: "block",
        fontSize: "20px",
    },
    yearMonthP: {
        marginTop: 0,
        marginBottom: 0,
    },
}

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        room: state.room,
        resvKaiinken: state.resvKaiinken,
        checkIn: state.checkIn,
        // grade: state.grade,
        gradeData: state.gradeData,
        // membershipFacility: state.membershipFacility, 使っていない
        adultNum: state.adultNum,
        childNum: state.childNum,
        kushitsuList: state.kushitsuList,
        vacancyWeek: state.vacancyWeek
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        // setGrade: (item) => {
        //     dispatch({ type: "GRADE", payload: { grade: item } })
        // },
        setFacilityItem: (item) => {
            dispatch({ type: "VACANCY_FACILITY", payload: { vacancyFacility: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        // setMembershipFacility: (item) => {
        //     dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        // },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setGradeData: (item) => {
            dispatch({ type: "GRADE_DATA", payload: { gradeData: item } })
        },
        setVacancyList: (item) => {
            dispatch({ type: "VACANCY_LIST", payload: { vacancyList: item } })
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VacancyContainer);